import React from 'react';

export const ArrowUpIcon = ({ size, props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size | 24}
    height={size | 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      className="arrowUp"
      d="M8.14644661,14.858836 C7.95118446,14.6635739 7.95118446,14.3469914 8.14644661,14.1517292 L12.4989857,9.79289322 L16.8573469,14.1517292 C17.052609,14.3469914 17.052609,14.6635739 16.8573469,14.858836 C16.6620847,15.0540981 16.3455022,15.0540981 16.1502401,14.858836 L12.4989857,11.2071068 L8.85355339,14.858836 C8.65829124,15.0540981 8.34170876,15.0540981 8.14644661,14.858836 Z"
    />
  </svg>
);
